import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { emailTemplateApi } from '../../../api/emailTemplateApi';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IEmailTemplate } from '../../../models/response/email/IEmailTemplate';
import { eEmailTemplateActionTypeIds, IEmailTemplateActionTypes } from '../../action-types/email/IEmailTemplateActionTypes';
import { actions } from '../../actions/actionsWrapper';
import { apiWrapper } from '../../../api/apiWrapper';
export function* emailTemplateSaga(): any {
    yield takeLatest(eEmailTemplateActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eEmailTemplateActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eEmailTemplateActionTypeIds.DELETE_START, deleteWorker)

}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(emailTemplateApi.selectAll)
    if (res.is_success) {
        yield put(actions.emailWrapper.template.LOAD_SUCCCES(res.data))
    } else {
        yield put(actions.emailWrapper.template.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IEmailTemplateActionTypes): any {
    const payload = action.payload as IEmailTemplate;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.email.emailTemplate.update, payload)
    } else {
        res = yield call(apiWrapper.email.emailTemplate.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.emailWrapper.template.SAVE_SUCCESS(res.data))
    } else {
        yield put(actions.emailWrapper.template.SAVE_ERROR(res.message ?? "Error"))
    }
}
function* deleteWorker(action: IEmailTemplateActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.email.emailTemplate.delete, payload)
    if (res.is_success) {
        yield put(actions.emailWrapper.template.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.emailWrapper.template.DELETE_ERROR(res.message ?? "Error"))
    }
}
